import { AuthenticationGuard } from './guards/authentication.guard';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes =
	[
		/**
		 * REDIRECTIONS
		 */
		{ path: '', redirectTo: 'login', pathMatch: 'full' },
		//{	path: '**', redirectTo: '/not-found', data: {} },

		/**
		 * DEFAULT STATES 
		 */
		{
			path: 'login',
			loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
		},
		{
			path: 'error-page',
			loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundPageModule),
			canActivate: [AuthenticationGuard]
		},

		/**
		 * APPLICATION STATES
		 */
		{
			path: 'initialize',
			loadChildren: () => import('./pages/initialize/initialize.module').then(m => m.InitializePageModule),
			canActivate: []
		},
		{
			path: 'dashboard',
			loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'backoffice-users',
			loadChildren: () => import('./pages/backoffice-users/users.module').then(m => m.UsersPageModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'militant-users',
			loadChildren: () => import('./pages/militant-users/militant.module').then(m => m.MilitantPageModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'sympathizers-users',
			loadChildren: () => import('./pages/sympathizers/sympathizers.module').then(m => m.SympathizersModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'process',
			loadChildren: () => import('./pages/process/process.module').then(m => m.ProcessPageModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'payments',
			loadChildren: () => import('./pages/payments/payments.module').then(m => m.PaymentsPageModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'elections',
			loadChildren: () => import('./pages/elections/elections.module').then(m => m.ElectionsPageModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'generic',
			loadChildren: () => import('./pages/others/others.module').then(m => m.OthersPageModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'reports',
			loadChildren: () => import('./pages/reports/reports.module').then(m => m.ReportsPageModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'congress',
			loadChildren: () => import('./pages/congress/congress.module').then(m => m.CongressPageModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'candidatures',
			loadChildren: () => import('./pages/candidatures/candidatures.module').then(m => m.CandidaturesModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'organs',
			loadChildren: () => import('./pages/organs/organs.module').then(m => m.OrgansPageModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'sections',
			loadChildren: () => import('./pages/sections/sections.module').then(m => m.SectionsPageModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'indicators',
			loadChildren: () => import('./pages/indicators/indicators.module').then(m => m.IndicatorsPageModule),
			canActivate: [AuthenticationGuard]
		},
		{
			path: 'correspondence',
			loadChildren: () => import('./pages/correspondence/correspondence.module').then(m => m.CorrespondencePageModule),
			canActivate: [AuthenticationGuard]
		},

		/**
		 * REDIRECTION FOR PAGE NOT FOUND
		 */
		{
			path: '**',
			redirectTo: '/error-page',
			data: {}
		},

	];

@NgModule(
	{
		imports:
			[
				/**
				 * useHash -> ativar no caso de se usar browsers antigos
				 * url passa a conter ex.: /#/'path'
				 */
				RouterModule.forRoot(routes, { useHash: false })
			],
		exports: [RouterModule]
	})
export class AppRoutingModule { }
